/**
 * Auto-generated documentation registry
 * Do not edit this file manually - it's generated by DocsRegistryPlugin
 * 
 * Generated: 2026-05-11T16:38:44.413Z
 */

import React from 'react';
import { ComponentType } from 'react';

import Doc0 from '../../docs/README.mdx';
import Doc1 from '../../docs/Release_Notes/Adapptio_v3.0.mdx';

export interface IDocMetadata {
	title: string;
	description?: string;
	keywords?: string[];
	order?: number;
	[key: string]: any;
}

export interface IDocEntry {
	path: string;
	filePath: string;
	metadata: IDocMetadata;
	component: ComponentType<any>;
}

export const docsRegistry: IDocEntry[] = [
	{
		path: "README",
		filePath: "README.mdx",
		metadata: {
		  "title": "Adapptio Documentation",
		  "description": "Adapptio platform documentation",
		  "keywords": [
		    "documentation",
		    "getting started",
		    "introduction"
		  ],
		  "lastModified": "2026-05-11T15:57:35.608Z",
		  "order": 1,
		  "flags": [
		    "work-in-progress"
		  ]
		},
		component: Doc0
	},
	{
		path: "Release_Notes/Adapptio_v3.0",
		filePath: "Release_Notes/Adapptio_v3.0.mdx",
		metadata: {
		  "title": "Adapptio v3.0",
		  "description": "Release notes for Adapptio version 3.0",
		  "keywords": [
		    "release notes"
		  ],
		  "lastModified": "2026-05-11T15:57:35.608Z",
		  "order": 1,
		  "flags": [
		    "needs-review"
		  ]
		},
		component: Doc1
	}
];
